import { IFeatureIFrameQuery, useFeatureIFrameQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

interface IUseFeatureIFrame {
  featureIFrameLoading: boolean;
  featureIFrame: IFeatureIFrameQuery['FeatureIFrame'];
}

export const useFeatureIFrame = (): IUseFeatureIFrame => {
  const { featureIFrameId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureIFrameQuery({
    variables: { featureIFrameId: 'feature-iFrame-singleton' },
    skip: !featureIFrameId,
  });

  const featureIFrame = data?.FeatureIFrame ?? null;
  const featureIFrameLoading = featureIdsLoading || loading;

  return { featureIFrameLoading, featureIFrame };
};
